import React from "react";
import type { FirebaseTimestamp } from "../../common/types/FirebaseTimestamp";
import { showTimeUntilDeadline } from "../../utils/time.util";
import { fromTimestampToDate } from "../../utils/timestamp.util";
import Tag from "./Tag";

export function deadlineToCSSColor(deadlineAt: Date) {
    const timeUntilDeadline = showTimeUntilDeadline(new Date(), deadlineAt);
    switch (timeUntilDeadline?.urgency) {
        case "overdue":
            return "var(--a-ds-deadline-overdue)";
        case "priority_1":
            return "var(--a-ds-deadline-priority1)";
        case "priority_2":
            return "var(--a-ds-deadline-priority2)";
        case "priority_3":
            return "var(--a-ds-deadline-priority3)";
        case "priority_4":
            return "var(--a-ds-deadline-priority4)";
        default:
            return undefined;
    }
}

const DeadlineTag = function DeadlineIndicator(props: {
    deadlineAt: FirebaseTimestamp | Date | null | undefined;
}) {
    const { deadlineAt } = props;

    const deadlineAsDate = deadlineAt
        ? deadlineAt instanceof Date
            ? deadlineAt
            : fromTimestampToDate(deadlineAt)
        : undefined;
    if (!deadlineAsDate) return null;

    const timeUntilDeadline = showTimeUntilDeadline(new Date(), deadlineAsDate);
    if (!timeUntilDeadline) return null;

    if (timeUntilDeadline.urgency === "overdue") {
        return (
            <Tag.XXSmall.DeadlineOverdue>
                {timeUntilDeadline.label}
            </Tag.XXSmall.DeadlineOverdue>
        );
    }
    if (timeUntilDeadline.urgency === "priority_1") {
        return (
            <Tag.XXSmall.DeadlinePrio1>
                {timeUntilDeadline.label}
            </Tag.XXSmall.DeadlinePrio1>
        );
    }
    if (timeUntilDeadline.urgency === "priority_2") {
        return (
            <Tag.XXSmall.DeadlinePrio2>
                {timeUntilDeadline.label}
            </Tag.XXSmall.DeadlinePrio2>
        );
    }
    if (timeUntilDeadline.urgency === "priority_3") {
        return (
            <Tag.XXSmall.DeadlinePrio3>
                {timeUntilDeadline.label}
            </Tag.XXSmall.DeadlinePrio3>
        );
    }
    if (timeUntilDeadline.urgency === "priority_4") {
        return (
            <Tag.XXSmall.DeadlinePrio4>
                {timeUntilDeadline.label}
            </Tag.XXSmall.DeadlinePrio4>
        );
    }

    return null;
};

export default DeadlineTag;
